// uploadDiag.js
//
// Lightweight, dependency-free diagnostics for the document upload flow.
// WHY: the failing step is the browser -> storage.googleapis.com PUT, which
// never touches our server, so it leaves no entry in any server log. The bug
// is also intermittent (brittle with >1 document). These helpers keep a
// structured record of every upload step in window.__uploadDiag so an
// intermittent failure can be inspected AFTER the fact, even if DevTools was
// not open when it happened.
//
// To read the last run, type `__uploadDiag` (or `__uploadDiagDump()`) in the
// browser console.
//
// This module only records — it must never alter upload behaviour.

const MAX_RECORDS = 200;

export function uploadDiag(event, data = {}) {
   const record = { t: new Date().toISOString(), event, ...data };
   try {
      if (typeof window !== "undefined") {
         if (!Array.isArray(window.__uploadDiag)) window.__uploadDiag = [];
         window.__uploadDiag.push(record);
         if (window.__uploadDiag.length > MAX_RECORDS) window.__uploadDiag.shift();
         if (typeof window.__uploadDiagDump !== "function") {
            window.__uploadDiagDump = uploadDiagDump;
         }
      }
   } catch {
      // Diagnostics must never break an upload.
   }
   // Mirror to the console so it is visible live when DevTools is open.
   console.log(`[UPLOAD_DIAG] ${event}`, record);
   return record;
}

export function uploadDiagDump() {
   const rows = (typeof window !== "undefined" && window.__uploadDiag) || [];
   try {
      console.table(rows);
   } catch {
      console.log("[UPLOAD_DIAG] dump", rows);
   }
   return rows;
}

// Reduce a signed GCS URL to host + path + the non-secret query params that
// matter for debugging (expiry / clock), without logging the signature.
export function describeSignedUrl(signedUrl) {
   try {
      const u = new URL(signedUrl);
      return {
         host: u.host,
         path: u.pathname,
         goerDate: u.searchParams.get("X-Goog-Date"),
         expires: u.searchParams.get("X-Goog-Expires"),
         signedHeaders: u.searchParams.get("X-Goog-SignedHeaders"),
      };
   } catch {
      return { host: null, path: null, raw: typeof signedUrl };
   }
}
